<template>
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
    <section class="content-header">      
      <h1>
      {{actionToBePerformed }}
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li><router-link to="/reengagement-manager/view">Back</router-link></li>        
        <li class="active">{{actionToBePerformed}}</li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-xs-12">
          <div class="box">
            <div class="box-body">
              <div class="col-xs-12 col-md-12 col-lg-12">
                <form  @submit.prevent="createOrUpdateReengagement"  method="post">
                  <div class="panel panel-default">
                    <div class="panel-heading">
                      <h3 class="panel-title">Step 1 | Reengagement Details</h3>
                    </div>
                    <div class="panel-body">
                      <div class="row">
                        <div class="col-md-12 col-lg-12 col-xs-12">
                          <div class="form-group col-xs-6 col-sm-6 col-md-6">
                            <label for="name" class="required"> Name</label>
                            <input type="text" v-bind:class="{'form-group--error': submitted && !$v.scheduleData.name.required }" v-model="scheduleData.name" 
                            autocomplete="off" class="form-control" id="opportunity_name" placeholder="Reengagement Name"  />
                            <span v-if="submitted &&  !$v.scheduleData.name.required" class="text-red pull-right">Please provide a reengagement name.</span>
                          </div>
                          <div class="form-group col-xs-6 col-sm-6 col-md-6">
                              <label for="type" class="required">Type</label>
                              <nv-select  disabled v-bind:class="{'form-group--error': submitted && !$v.scheduleData.type.required }" v-model="scheduleData.type" class="form-control" id="Client">
                                <option value="">--Select a reengagement type--</option>
                                <option value="one-time batch">one-time batch</option>
                                <option value="automated trigger">automated trigger</option>
                              </nv-select>
                              <span v-if="submitted && !$v.scheduleData.type.required" class="text-red pull-right">Please choose a reengagement type.</span>
                            </div>
                        </div>
                      </div>
                       <div class="row">
                        <div class="col-md-12 col-lg-12 col-xs-12">
                          <div class="form-group col-xs-6 col-sm-6 col-md-6">
                            <label class="required">Country</label>
                            <nv-select v-bind:class="{'form-group--error': submitted && !$v.scheduleData.country.required }" v-model="scheduleData.country"  class="form-control" v-on:change="handleCountryChange()" >
                            <option value="">--Choose a country--</option>
                            <option v-for="(value, key) in countryList" :key="key" :value="value.country_id">{{value.country_name}}</option>
                          </nv-select>
                          <span v-if="submitted && !$v.scheduleData.country.required" class="text-red pull-right">Please choose a country.</span>
                          </div>
                          <div class="form-group col-xs-6 col-sm-6 col-md-6">
                              <label class="checkbox-inline" style="margin-top: 30px">
                                <input type="checkbox" v-model="scheduleData.isNewUserBatch" />
                                  <b>is New User Batch</b>
                                  <span title="Please check if users are added manually"><i class="fa fa-info-circle margin-10"></i></span>
                              </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="panel panel-default">
                    <div class="panel-heading">
                      <h3 class="panel-title">Step 2 | Select Audience</h3>
                    </div>
                    <div class="panel-body">
                      <div class="row">
                        <div class="col-md-12 col-lg-12 col-xs-12">
                          <div class="form-group col-xs-6 col-sm-6 col-md-6">
                              <label for="audience" >Audience</label>
                              <nv-select v-bind:class="{'form-group--error': submitted && !$v.scheduleData.audience.required }" v-model="scheduleData.audience" class="form-control" id="audience" >
                                <option value="">--Choose an audience--</option>
                                <option v-for="(data, index) in audienceList" 
                                :key="index" :value="data.id">{{data.query_name}}</option>                    
                              </nv-select>                              
                              <span v-if="submitted && !$v.scheduleData.audience.required" class="text-red pull-right">Please choose an audience.</span>
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="panel panel-default">
                    <div class="panel-heading">
                      <h3 class="panel-title">Step 3 | Message &amp; Details
                        <small v-if="turnCountry" style="margin-left: 10px">Nudge templates from <b>{{turnCountry}}</b></small>
                      </h3>
                    </div>
                    <div class="panel-body">

                      <div class="row">
                        <div class="col-md-12 col-lg-12 col-xs-12">
                          <div class="form-group col-xs-12 col-sm-12 col-md-12">
                            <div v-for="splitOptn in splitOptions" :key="splitOptn.value">
                              <label class="radio-inline col-xs-4 col-sm-4 col-md-2 col-lg-2">
                                <input type="radio" v-model="split_type" :value="splitOptn.value" @change="onSplitTypeChange"/>{{splitOptn.label}}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row" style="margin-top: 15px;">
                        <div class="col-md-12 col-lg-12 col-xs-12">
                          <div class="form-group col-xs-12 col-sm-12 col-md-12">
                            <div style="font-weight: bold">
                            <button type="button" class="btn btn-primary btn-rounded btn-nudge" @click="addGroup"><i class="fa fa-plus" aria-hidden="true"></i></button> Add New Group
                          </div>
                          </div>
                        </div>
                      </div>

                    
                        <div v-for="(item, index) in groupList" :key="index">
                          <div class="panel panel-default panel-group-container">
                            <div class="panel-heading">
                              <h3 class="panel-title group-title">Group {{index + 1}}
                                <div class="remove-group-btn-container">
                                  <button type="button" class="btn btn-rounded btn-remove-nudge btn-nudge btn-danger col-xs-2 col-sm-2 col-md-2 col-2" style="margin-right: 5px;" @click="removeGroup(index)">
                                    <i class="fa fa-minus" aria-hidden="true"></i>
                                  </button>
                                  Remove Group

                              </div>
                              </h3>
                              
                            </div>
                            <div class="panel-body">
                              
                              <div class="row">
                              <div class="col-md-12 col-lg-12 col-xs-12">
                                <div class="form-group col-xs-12 col-sm-12 col-md-12">
                                  <label >Nudge</label>
                                  <div>
                                  <div class="col-xs-6 col-sm-6 col-md-6" style="padding-left: 0px;">
                                  <treeselect
                                    v-bind:class="{'form-group--error': submitted && !$v.groupList.$each[index].msg_template_id.required }"
                                    placeholder="--Choose a nudge--" 
                                    :multiple="false" 
                                    :options="nudgesList" 
                                    v-model="item.msg_template_id" />
                                    <span v-if="submitted && !$v.groupList.$each[index].msg_template_id.required" class="text-red pull-right">Please choose a nudge.</span>
                                  </div>
                                  <div v-if="item.msg_template_id" class="col-xs-6 col-sm-6 col-md-6" style="padding: 0px; margin-left: -15px;">
                                    <button type="button" class="btn btn-link" @click="onNudgePreviewClick(item.msg_template_id)">Preview</button>
                                  </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-12 col-lg-12 col-xs-12 keyword-conversation-container">
                                <div class="form-group col-xs-6 col-sm-6 col-md-6">
                                  <label >Keyword</label>
                                  <treeselect
                                    v-bind:class="{'form-group--error': submitted && !$v.groupList.$each[index].keyword_id.required }"
                                    placeholder="--Choose a keyword--" 
                                    :multiple="false"
                                    :disabled="!!item.conversation_id"
                                    :options="keywordsList"
                                    v-model="item.keyword_id" />
                                  <span v-if="submitted && !$v.groupList.$each[index].keyword_id.required" class="text-red pull-right">Please choose a keyword.</span>
                                </div>
                                <div class="or-container col-xs-1 col-sm-1 col-md-1">OR</div>
                                <div class="form-group col-xs-5 col-sm-5 col-md-5">
                                  <label >Conversation OR Journey</label>
                                  <treeselect
                                    v-bind:class="{'form-group--error': submitted && !$v.groupList.$each[index].conversation_id.required }"
                                    placeholder="--Choose a conversation--"
                                    :disabled="!!item.keyword_id" 
                                    :multiple="false" 
                                    :options="conversationList" 
                                    v-model="item.conversation_id" />
                                  <span v-if="submitted && !$v.groupList.$each[index].conversation_id.required" class="text-red pull-right">Please choose a conversation.</span>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-12 col-lg-12 col-xs-12">
                                <div class="form-group col-xs-6 col-sm-6 col-md-6">
                                  <label>Destination</label>
                                  <treeselect
                                    v-bind:class="{'form-group--error': submitted && !$v.groupList.$each[index].destination_app_name.required }"
                                    placeholder="--Choose a conversation--" 
                                    :multiple="false" 
                                    :options="destinationList" 
                                    v-model="item.destination_app_name" />
                                <span v-if="submitted && !$v.groupList.$each[index].destination_app_name.required" class="text-red pull-right">Please choose a conversation.</span>
                                </div>
                                <div class="or-container col-xs-1 col-sm-1 col-md-1"></div>

                                <div class="form-group col-xs-5 col-sm-5 col-md-5">
                                  <label>Split (%)</label>
                                  <input type="text" v-bind:class="{'form-group--error': submitted && (!$v.groupList.$each[index].split_percent.required || !$v.groupList.$each[index].split_percent.minValue || !$v.groupList.$each[index].split_percent.maxValue || !$v.groupList.$each[index].split_percent.numeric)}" v-model="item.split_percent" :disabled="split_type === 'EQUAL'"
                                  autocomplete="off" class="form-control" id="opportunity_name" placeholder="Split Percentage out of 100"  />
                                  <span v-if="submitted && !$v.groupList.$each[index].split_percent.required" class="text-red pull-left">Please enter split percentage.</span>
                                  <span v-if="submitted && (!$v.groupList.$each[index].split_percent.minValue || !$v.groupList.$each[index].split_percent.maxValue)" class="text-red pull-left">Please enter number between 1 to 100.</span>
                                  <span v-if="submitted && !$v.groupList.$each[index].split_percent.numeric" class="text-red pull-left">Please enter valid integer value.</span>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>


                    </div>
                  </div>
                  <div class="panel panel-default">
                    <div class="panel-heading">
                      <h3 class="panel-title">Step 4 | Deployment</h3>
                    </div>
                    <div class="panel-body">                      
                      <div class="row">
                        <div class=" form-group col-md-6 col-lg-6 col-xs-6">                         
                          <label  >Select Deployment Date</label>
                          <input :min="getDate()" v-bind:class="{'form-group--error': submitted && !$v.scheduleData.deploymentDate.required }" v-model="scheduleData.deploymentDate" type="date"  class="form-control" >
                          <span v-if="submitted && !$v.scheduleData.deploymentDate.required" class="text-red pull-right">Please choose a deployment date.</span>
                        </div>
                        <div class="form-group col-xs-6 col-lg-6 col-sm-6 col-md-6">
                          <label >Select Deployment Time</label>
                          <input type="time" class="form-control" v-bind:class="{'form-group--error': submitted && !$v.scheduleData.deploymentTime.required }" v-model="scheduleData.deploymentTime" />
                          <span v-if="submitted && !$v.scheduleData.deploymentTime.required" class="text-red pull-right">Please choose a deployment date.</span>
                        </div>
                      </div>
                      </div>
                  </div>
                  <div class="row">
                    <div class="action-button">
                      <input type="submit" class="btn btn-primary margin-left-20px" v-on:click="setReengagementAction(true)" value="SAVE AS DRAFT" />
                      <input type="submit" class="btn btn-primary margin-left-20px" v-on:click="setReengagementAction(false)" value="SAVE &amp; SCHEDULE" />
                      <input type="button" class="btn btn-primary margin-left-20px" value="CANCEL" v-on:click="resetForm()"/>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="modal-backdrop" v-if="showNudgePreview">
      <div class="modal modal-md" style="max-width:800px; height: max-content">
          <div style="margin: 20px; max-height: 400px; overflow-y: auto;">
            <slot name="body">
              <div class="margin-bottom-10px">
                <template v-if="showCountryPicker">
                  <label class="required">Country</label>
                  <nv-select class="form-control" style="display:inline-block; min-width:180px; vertical-align:middle; margin-left:8px" v-model="turnCountry" v-on:change="onTurnCountryChange()">
                    <option value="">-- Select Country --</option>
                    <option v-for="country in turnCountryList" :key="country" :value="country">{{country}}</option>
                  </nv-select>
                  <div style="margin-top:8px">Templates differ per country's Turn namespace. Select a country to load them.</div>
                </template>
                <template v-else>
                  <span>Templates from <b>{{turnCountry}}</b></span>
                  <button v-if="turnCountryList.length > 1" type="button" class="btn btn-link" v-on:click="showCountryPicker = true">Change Country</button>
                </template>
              </div>
              <div v-if="turnCountry">
              <div class="nudge-origin-title">WhatsApp Nudge(s):</div>
              <div class="margin-bottom-10px" v-for="(data, index) in nudgePreviewData" :key="index">
                <span class="nudge-language">{{data.language}} :</span>
                <!-- A media header: the file set on the template (campaign country's copy). -->
                <div v-if="data.turn_template_data && ['IMAGE', 'VIDEO', 'DOCUMENT'].includes(data.turn_template_data.HEADER_FORMAT)" style="max-width: 260px">
                  <media-preview
                    :format="data.turn_template_data.HEADER_FORMAT"
                    :media-id="data.media_id"
                    :media-name="data.media_name || ''"
                    :file-name="data.media_file_name || ''"
                    :country-id="scheduleData.country || null"
                    :language-id="data.language_id"
                  />
                </div>
                <div v-if="data.turn_template_data && data.turn_template_data.HEADER" class="nudge-whatsapp-header">{{data.turn_template_data.HEADER}}</div>
                <div v-if="data.turn_template_data && data.turn_template_data.BODY" class="nudge-whatsapp-body">{{data.turn_template_data.BODY}}</div>
                <div v-if="data.turn_template_data && data.turn_template_data.FOOTER" class="nudge-whatsapp-footer">{{data.turn_template_data.FOOTER}}</div>
                <div v-if="data.turn_template_data && data.turn_template_data.BUTTONS" style="margin-top: 5px">
                  <span v-for="(button, index) in data.turn_template_data.BUTTONS" :key="index" class="nudge-whatsapp-button">{{button}}</span>
                </div>
                <div v-if="!data.turn_template_data" class="nudge-whatsapp-body"> -- Not available in {{turnCountry}} -- </div>
              </div>

              <div class="nudge-origin-title" style="margin-top: 15px">Facebook Nudge(s):</div>
              <div class="margin-bottom-10px" v-for="(data, index) in nudgePreviewData" :key="index">
                <span class="nudge-language">{{data.language}} :</span>
                <div v-if="data.fb_nudge_text" class="nudge-whatsapp-body">{{data.fb_nudge_text}}</div>
                <div v-else class="nudge-whatsapp-body"> -- No data available -- </div>
              </div>
              </div>
            </slot>
          </div>
          
          <div class="modal-footer" style="margin-top: auto; padding: 0px">
            <div class="form-group pull-right" style="margin-top: 10px">
              <div class="col-sm-12">
                <button type="button" class="btn btn-primary" @click="closeNudgePreview">Close</button> 
              </div>
            </div>
          </div>
      </div>
    </div>
    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>
  </div>
</template>
<script>
import { requiredIf, required, minValue, maxValue, numeric } from 'vuelidate/lib/validators'
import api from '../../../utils/api'
import MediaPreview from '../common/MediaPreview.vue'
import moment from 'moment'
import { splitOptions, maxReengagementGroupsAllowed } from './constant'

export default {
  name: 'reengagement',
  components: { MediaPreview },
  validations: {
    scheduleData: {
      name: { required },
      type: { required },
      country: { required },
      audience: { required: requiredIf(function () {
        return !this.isDraft
      })},
      deploymentDate: { required: requiredIf(function () {
        return !this.isDraft || this.scheduleData.deploymentTime
      })},
      deploymentTime: { required: requiredIf(function () {
        return !this.isDraft || this.scheduleData.deploymentDate
      })}
    },
    groupList: {
      $each: {
        msg_template_id: { required: requiredIf(function () {
          return !this.isDraft
        })},
        keyword_id: { required: requiredIf(function (prop) {
          return !this.isDraft && !prop.conversation_id
        })},
        conversation_id: { required: requiredIf(function (prop) {
          return !this.isDraft && !prop.keyword_id
        })},
        destination_app_name: { required: requiredIf(function () {
          return !this.isDraft
        })},
        split_percent: { required: requiredIf(function () {
          return !this.isDraft
        }),
          minValue: minValue(1),
          maxValue: maxValue(100),
          numeric
        }
      }
    }
  },
  data () {
    return {
      loading: true,
      splitOptions: splitOptions,
      scheduleData: {
        name: '',
        type: 'one-time batch',
        audience: '',
        deploymentDate: '',
        deploymentTime: '',
        country: '',
        schedule: '',
        isNewUserBatch: false
      },
      split_type: 'EQUAL',
      copyOfName: '',
      timezone: '',
      keywordsList: [],
      nudgesList: [],
      audienceList: [],
      conversationList: [],
      destinationList: [],
      templateList: [],
      countryList: [],
      reengagementTypes: ['one-time batch', 'automated trigger'],
      submitted: false,
      isDraft: false,
      action: '',
      actionToBePerformed: 'Create Reengagement',
      showNudgePreview: false,
      nudgePreviewData: [],
      turnCountry: '',
      turnCountryList: [],
      showCountryPicker: false,
      pendingNudgePreview: null,
      groupList: [{
        msg_template_id: null,
        keyword_id: null,
        conversation_id: null,
        destination_app_name: null,
        split_percent: null
      }]
    }
  },
  methods: {
    addGroup () {
      if (this.groupList.length === maxReengagementGroupsAllowed) {
        this.$swal({
          type: 'error',
          text: `Maximum only ${maxReengagementGroupsAllowed} groups can be created`
        })
        return
      }
      this.groupList.push({
        msg_template_id: null,
        keyword_id: null,
        conversation_id: null,
        destination_app_name: null,
        split_percent: null
      })
      this.setNewSplitData()
    },
    removeGroup (index) {
      this.groupList.splice(index, 1)
      this.setNewSplitData()
    },
    onSplitTypeChange (val) {
      this.setNewSplitData()
    },
    setNewSplitData () {
      if (this.split_type === 'EQUAL' && this.groupList.length) {
        const num = 100
        const parts = this.groupList.length

        let counter = 0
        let split = Math.floor(num / parts)
        let rem = num % parts
        if (rem !== 0) counter = rem
        this.groupList.forEach((element, index) => {
          let per = split
          if (counter > 0) per = per + 1
          element.split_percent = per
          counter = counter - 1
        })
      }
    },
    closeNudgePreview () {
      this.showNudgePreview = false
      this.pendingNudgePreview = null
    },
    async getTurnCountryList () {
      if (this.turnCountryList.length) return
      try {
        const response = await api.buildRequest('getQuickLinkConfig', 'POST')
        const whatsapp = (response.data.payload && response.data.payload.whatsapp) || {}
        this.turnCountryList = Object.keys(whatsapp)
      } catch (error) {
        console.error('Failed to fetch WhatsApp country list', error)
      }
    },
    onTurnCountryChange () {
      if (this.turnCountry) {
        this.showCountryPicker = false
        if (this.pendingNudgePreview !== null) this.loadNudgePreview()
      }
    },
    /**
     * @description opens the preview popup on the country picked earlier while editing this
     * campaign, and asks for one when there is no usable choice yet. The country is kept in
     * component state only, so it resets on a page change or refresh.
     */
    async onNudgePreviewClick (nudge) {
      this.pendingNudgePreview = nudge
      this.nudgePreviewData = []
      this.loading = true
      await this.getTurnCountryList()
      if (!this.turnCountryList.includes(this.turnCountry)) this.turnCountry = ''
      this.showCountryPicker = !this.turnCountry
      this.loading = false
      this.showNudgePreview = true
      if (this.turnCountry) this.loadNudgePreview()
    },
    async loadNudgePreview () {
      const nudge = this.pendingNudgePreview
      try {
        this.loading = true
        const response = await api.buildRequest(`getNudgePreview`, 'GET', { nudge: this.nudgesList.find(item => item.id === nudge).label, country: this.turnCountry })
        console.log('response: ', response)
        this.showNudgePreview = true
        this.nudgePreviewData = response.data.payload
        this.loading = false
      } catch (error) {
        console.log(error)
        this.nudgePreviewData = []
        this.loading = false
        this.$swal({
          type: 'error',
          text: error.response ? error.response.data.payload.message : 'An error occurred'
        })
      }
    },

    setReengagementAction (action) {
      this.isDraft = action
    },

    resetForm () {
      this.$router.push({ name: 'reengagement-manager/view' })
    },

    getDate () {
      return moment(new Date()).format('YYYY-MM-DD')
    },

    handleTimeZoneChange () {
      // Convert Country specific time to UTC
      const time = moment.tz(`${this.scheduleData.deploymentDate} ${this.scheduleData.deploymentTime}`, this.timezone)
      this.scheduleData.schedule = time.utc().format()
    },

    handleCountryChange () {
      const country = this.countryList.filter(country => country.country_id === this.scheduleData.country)
      if (country.length > 0) {
        this.getTimeZone({ country: country[0].country_name })
      }
      if (this.scheduleData.country && this.countryList.length) {
        this.getKeywordsList({ countryId: this.scheduleData.country })
        this.getAudienceList(this.scheduleData.country)
      }
    },

    async createOrUpdateReengagement () {
      this.submitted = true
      this.$v.scheduleData.$touch()

      if (this.groupList.length) {
        const sum = this.groupList.reduce((accumulator, object) => {
          return accumulator + Number(object.split_percent)
        }, 0)
        console.log('sum: ', sum)
        if (sum !== 100) {
          this.$swal({
            type: 'error',
            text: 'Total split percentage should be 100'
          })
          return
        }
      } else if (!this.isDraft) {
        this.$swal({
          type: 'error',
          text: 'Please add at least one message group to schedule the reengagement'
        })
        return
      }
      if (this.$v.$invalid) {
        return
      }

      const data = this.scheduleData
      if (this.scheduleData.deploymentDate && this.scheduleData.deploymentTime) {
        this.handleTimeZoneChange()
      }

      this.groupList.map((item, index) => (item.group_name = `Group ${index + 1}`))
      const reengagementDetails = {
        campaign_name: data.name ? data.name : null,
        campaign_type: data.type ? data.type : null,
        country_id: data.country ? data.country : null,
        audience_id: data.audience ? data.audience : null,
        status: this.isDraft ? 'Draft' : 'Scheduled',
        schedule: data.schedule ? data.schedule : null,
        split_type: this.split_type,
        group_list: this.groupList,
        isNewUserBatch: data.isNewUserBatch ? data.isNewUserBatch : false
      }

      console.log('reengagementDetails : ', reengagementDetails)
      if (!this.$route.params.campaignId) {
        try {
          this.loading = true
          const response = await api.buildRequest('/createReengagement', 'POST', reengagementDetails)
          this.loading = false
          this.$swal({
            title: 'Success',
            type: 'success',
            text: response.data.payload.message ? response.data.payload.message : 'Created reengagement successfully'
          }).then(() => {
            this.$router.push({ name: 'reengagement-manager/view' })
          })
        } catch (err) {
          this.loading = false
          this.$swal({
            title: 'Failure',
            type: 'error',
            text: err.response.data.payload.message ? err.response.data.payload.message : 'Error while creating reengagement'
          })
        }
      } else {
        try {
          this.loading = true
          reengagementDetails.id = this.$route.params.campaignId
          reengagementDetails.existingName = this.copyOfName
          const response = await api.buildRequest('/updateReengagement', 'POST', reengagementDetails)
          this.loading = false
          this.$swal({
            title: 'Success',
            type: 'success',
            text: response.data.payload.message ? response.data.payload.message : 'Updated reengagement successfully'
          }).then(() => {
            this.$router.push({ name: 'reengagement-manager/view' })
          })
        } catch (err) {
          this.loading = false
          this.$swal({
            title: 'Failure',
            type: 'error',
            text: err.response.data.payload.message ? err.response.data.payload.message : 'Error while updating reengagement'
          })
        }
      }
    },

    async getAudienceList (countryId) {
      try {
        const response = await api.buildRequest('getAudienceList', 'POST', {countryId})
        this.audienceList = response.data.payload.filter(audience => audience.id !== 0)
      } catch (err) {
        this.loading = false
        this.$swal({
          type: 'error',
          text: err.response ? err.response.data.payload.message : 'An error occurred'
        })
      }
    },

    async fetchReengagementDetails (param) {
      try {
        const response = await api.buildRequest('getReengagementDetails', 'POST', { campaignId: param })
        const data = response.data.payload
        await this.getKeywordsList({ country: data.country_id })
        await this.getAudienceList(data.country_id)
        const country = this.countryList.filter(country => country.country_id === data.country_id)
        if (country.length > 0) {
          await this.getTimeZone({ country: country[0].country_name })
        }

        this.copyOfName = data.campaign_name ? data.campaign_name : ''
        this.actionToBePerformed = 'Update Reengagement Details'
        this.scheduleData = {
          name: data.campaign_name ? data.campaign_name : '',
          type: data.campaign_type ? data.campaign_type : 'one-time batch',
          audience: data.audience_id ? data.audience_id : '',
          country: data.country_id ? data.country_id : '',
          deploymentDate: data.schedule ? moment(data.schedule).tz(this.timezone).format('YYYY-MM-DD') : '',
          deploymentTime: data.schedule ? moment(data.schedule).tz(this.timezone).format('HH:mm') : '',
          isNewUserBatch: data.is_new_user_batch ? data.is_new_user_batch : false
        }
        this.split_type = data.split_type || 'EQUAL'
        this.groupList = data.group_list
        this.loading = false
      } catch (err) {
        this.loading = false
        this.$swal({
          type: 'error',
          text: err.response ? err.response.data.payload.message : 'An error occurred'
        })
      }
    },

    async getTimeZone (param) {
      try {
        const response = await api.buildRequest(`getTimezone`, 'POST', param)
        this.timezone = response.data.payload
      } catch (error) {
        this.$swal({
          type: 'error',
          text: error.response ? error.response.data.payload.message : 'An error occurred'
        })
      }
    },

    async getKeywordsList (param) {
      try {
        const response = await api.buildRequest(`getAllKeywords`, 'POST', param)
        this.keywordsList = response.data.payload.map(keyword => { return { id: keyword.id, label: keyword.keyword } })
      } catch (error) {
        this.$swal({
          type: 'error',
          text: error.response ? error.response.data.payload.message : 'An error occurred'
        })
      }
    },

    async getConversationList () {
      try {
        const response = await api.buildRequest(`getDeployedApps`, 'GET')
        for (let app of response.data.payload) {
          this.destinationList.push({ id: app.appName, label: app.appName })
          this.conversationList.push({ id: app.id, label: app.appName })
        }
      } catch (error) {
        this.loading = false
        this.$swal({
          type: 'error',
          text: error.response ? error.response.data.payload.message : 'An error occurred'
        })
      }
    },

    async getCountryList () {
      try {
        const response = await api.buildRequest('getCountryList', 'POST')
        this.countryList = response.data.payload.filter(country => country.country_name !== 'Global')
      } catch (error) {
        this.loading = false
        this.$swal({
          type: 'error',
          text: error.response ? error.response.data.payload.message : 'An error occurred'
        })
      }
    },

    async getNudgesList () {
      try {
        const response = await api.buildRequest(`reengagement/nudges`, 'POST')
        this.nudgesList = response.data.payload.map(nudge => { return { id: nudge.id, label: nudge.msg_template_name } })
      } catch (error) {
        this.loading = false
        this.$swal({
          type: 'error',
          text: error.response ? error.response.data.payload.message : 'An error occurred'
        })
      }
    }

  },
  async mounted () {
    await this.getCountryList()
    await this.getConversationList()
    await this.getNudgesList()
    this.setNewSplitData()
    if (this.$route && this.$route.params && this.$route.params.campaignId) {
      this.fetchReengagementDetails(this.$route.params.campaignId)
    } else this.loading = false
  }
}
</script>
<style>
.message {
  overflow: auto;
  max-height: 200px;
  max-width: 400px;
}
.text-wrap {
  white-space: pre-wrap;
}
.paddingTop7px {
  padding-top: 7px;
}
.remove-group-btn-container {
  font-weight: bold;
  font-size: 14px;
  height: min-content;
  display: flex;
  align-items: center;
}
.group-title {
  display: flex;
  justify-content: space-between;
  color: #333333;
}
.text-underline {
  text-decoration: underline;    
}
.padding10px {
  padding: 10px;
}
.margin-top-5px {
  margin-top:5px;
}
.margin-bottom-10px {
  margin-bottom:10px;
}
.or-container {
  font-weight: bold;
  text-align: center;
}
.keyword-conversation-container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.nudge-language {
  font-weight: bold;
  font-size: 15px;
  text-decoration: underline;
}
.nudge-whatsapp-header {
  margin-bottom: 5px;
  font-weight: 700;
}
.nudge-whatsapp-footer {
  margin-top: 5px;
  font-weight: 100;
}
.nudge-whatsapp-button {
  padding: 2px 15px;
  background: #dedede;
  margin-right: 10px;
  border-radius: 5px;
  cursor: pointer;
  color: #3973ca;
}
.nudge-origin-title {
  font-size: 20px;
  font-weight: bold;
}
.panel-group-container {
  margin: 0px 15px 15px 15px;
}
</style>



// WEBPACK FOOTER //
// createOrUpdateReengagement.vue?cd5c80c2